import React, { useState } from 'react';
import { FaTimes, FaMapMarkerAlt } from 'react-icons/fa';
import EarthquakeControls from './EarthquakeControls';
import ScenarioList from './ScenarioList';

// Mobile-only: a floating "Define Scenario" CTA opens the Magnitude/Lat/Lng
// form + Nearest Scenarios list as a bottom sheet. Desktop/tablet use the
// classic floating SearchPanel + ScenarioPanel instead — see App.js.
export default function ControlPanel({ hasResults, ...contentProps }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button className="define-scenario-cta" onClick={() => setOpen(true)}>
        <FaMapMarkerAlt size={15} />
        Define Scenario
        {hasResults && <span className="cta-badge" />}
      </button>
      {open && <div className="sheet-backdrop" onClick={close} />}
      <div className={`control-sidebar control-sidebar--sheet${open ? ' open' : ''}`}>
        <div className="sheet-header">
          <span className="sheet-handle" />
          <button className="sheet-close" onClick={close} title="Close">
            <FaTimes size={14} />
          </button>
        </div>

        <EarthquakeControls
          magnitude={contentProps.magnitude}
          onMagnitudeSelect={contentProps.onMagnitudeSelect}
          searchCoords={contentProps.searchCoords}
          onSearch={contentProps.onSearch}
          onAfterAction={close}
        />
        <div className="control-divider" />
        <ScenarioList
          results={contentProps.results}
          selected={contentProps.selected}
          onSelect={contentProps.onSelect}
          searchPin={contentProps.searchPin}
          maxCoastal={contentProps.maxCoastal}
          onAfterAction={close}
        />
      </div>
    </>
  );
}
